package com.downdogapp.client.widget

import com.downdogapp.client.AbstractView
import com.downdogapp.client.AppPage

abstract class TopLevelView : AbstractView() {

  var fg: Foreground? = null
  var bg: Background? = null

  open fun refreshView() {
    fg?.refresh()
    bg?.refresh()
  }

  var spinnerShowing by AppPage::spinnerShowing

  fun showSpinner() {
    spinnerShowing = true
  }
  
  fun hideSpinner() {
    spinnerShowing = false
  }
}
